import apiClient from "@/shared/api/apiClient";

export const getPermissionList = async (params) => {
  try {
    const { data } = await apiClient.get("/permissions/codes/", {
      params,
    });
    return data;
  } catch (e) {
    console.error("getPermissionList failed", e);
  }
};

export const getPermissionGroupedList = async (params) => {
  try {
    const { data } = await apiClient.get("/permissions/grouped/", {
      params,
    });
    return data;
  } catch (e) {
    console.error("getPermissionGroupedList failed", e);
  }
};

export const createPermission = async (params) => {
  const result = await apiClient.post(`/permissions/`, {
    ...params,
  });
  return result.data;
};

export const updatePermission = async (id, params) => {
  const { data } = await apiClient.put(`/permissions/${id}`, {
    ...params,
  });
  return data;
};

export const deletePermission = async (id, params) => {
  const { data } = await apiClient.delete(`/permissions/${id}`, {
    ...params,
  });
  return data;
};

/*
CREATE_USER = "ACU" # Создание пользователя
UPDATE_USER = "AUU" # Изменение пользователя
DELETE_USER = "ADU" # Удаление пользователя
VIEW_USERS = "AVU" # Просмотр пользователя

CREATE_ORGANIZATION = "ACO" # Создание организации
UPDATE_ORGANIZATION = "AUO" # Изменение организации
UPDATE_ORGANIZATION_ROLES = "UOR" # Изменение роли организации
DELETE_ORGANIZATION = "ADO" # Удаление организации
VIEW_ORGANIZATIONS = "AVO" # Просмотр организации

CREATE_ROLE = "ACR" # Создание роли
UPDATE_ROLE = "AUR" # Изменение роли
DELETE_ROLE = "ADR" # Удаление роли

VIEW_ROLES = "AVR" # Просмотр роли
CREATE_PERMISSION = "ACP" # Создание разрешений
UPDATE_PERMISSION = "AUP" # Изменение разрешений
DELETE_PERMISSION = "ADP" # Удаление разрешений

VIEW_PERMISSION = "AVP" # Просмотр разрешений
CHANGE_ROLE_USER = "CRU" # Изменение роли у пользователя
# TG
VIEW_DOCUMENT_TYPES = "TVD" # Получить список типов документов
CREATE_DOCUMENT_TYPES = "TCD"  # Создание тип документа
UPDATE_DOCUMENT_TYPES = "TUD"  # Обновить тип документа
DELETE_DOCUMENT_TYPES = "TUD"  # Удаление тип документа

VIEW_PARTICIPANT_TYPE = "TVP"  # Получить список типов участников
CREATE_PARTICIPANT_TYPE = "TCP"  # Создать тип участника
UPDATE_PARTICIPANT_TYPE = "UDP"  # Обновить тип участника
DELETE_PARTICIPANT_TYPE = "DDP"  # Удаление тип участника

VIEW_FORM_TEMPLATES = "TVT"  # Получить список шаблонов форм
CREATE_FORM_TEMPLATES = "TCT"  # Создать шаблон формы
UPDATE_FORM_TEMPLATES = "TUT"  # Обновить шаблон формы
DELETE_FORM_TEMPLATES = "TDT"  # Удаление шаблон формы

VIEW_NOTARY_TRANSACTION = "TVNT"  # Получить список шаблонов форм
CREATE_NOTARY_TRANSACTION = "TCNT"  # Создать шаблон формы
UPDATE_NOTARY_TRANSACTION = "UDNT"  # Обновить шаблон формы
DELETE_NOTARY_TRANSACTION = "TDNT"  # Удаление шаблон формы
 */
